/**
 * The values `OrderV2.deliveryType` can take, named. The single source for the labels in
 * `utils/orderRowFields` and the order-type filter in `utils/orderFilters`, so a filter can never
 * select on a number the labels are not keyed on.
 */
export const DELIVERY_TYPES = { pickup: 0, delivery: 1, eatin: 2, hotStop: 3 } as const;

export const baseDoughShortName: { [key: number]: string } = {
  2611: '',
  2618: 'RUNK',
  2660: 'GLUT',
  2781: 'TORT',
  2855: 'KETO',
  2864: 'HJ',
} as const;
